module.exports = __webpack_public_path__ + "img/four.ba11cd3b.png";